import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import v3search from '@/components/v3/search'
import v3news from '@/components/v3/news'
import v3newsDetail from '@/components/v3/newsDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: "智生活"
      }
    },
    { // v3 新增
      path: '/v3news',
      name: 'v3news',
      component: v3news,
      meta: {
        title: "充電站",
        keepAlive: true
      }
    },
    { // v3 新增
      path: '/v3search',
      name: 'v3search',
      component: v3search,
      meta: {
        title: "充電站",
        keepAlive: true
      }
    },
    { // v3 新增
      path: '/v3newsDetail/:id',
      name: 'v3newsDetail',
      component: v3newsDetail,
      meta: {
        title: "充電站",
        keepAlive: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js